(function (Drupal) {
  'use strict';
  Drupal.behaviors.carBrands = {
    attach: function(context, settings) {

      const items = context.querySelectorAll('.paragraph .car-make');

      const addFadeClass = function() {
        const parent = this.closest('.paragraph');
        parent.querySelectorAll('.car-make').forEach(function(item) {
          if (item !== this) {
            item.classList.add('car-make-fade');
          }
        }, this);
      };

      const removeFadeClass = function() {
        const parent = this.closest('.paragraph');
        parent.querySelectorAll('.car-make').forEach(function(item) {
          if (item !== this) {
            item.classList.remove('car-make-fade');
          }
        }, this);
      };

      items.forEach(function(item) {
        item.addEventListener('mouseenter', addFadeClass);
        item.addEventListener('mouseleave', removeFadeClass);
      });

    }
  };
})(Drupal);
